import { Link } from 'react-router-dom';

/**
 * 404 — Rendered by the catch-all route in App.jsx for any unknown SPA path.
 * Intentionally a real dead-end (not a silent redirect) so typos and broken
 * inbound links surface instead of being swallowed.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div
          className="w-11 h-11 rounded-xl mx-auto mb-6 flex items-center justify-center text-white font-extrabold text-xl"
          style={{ background: 'linear-gradient(135deg, #4F46E5, #6366F1)' }}
        >
          S
        </div>

        <p className="text-sm font-semibold tracking-wider text-indigo-600 uppercase mb-3">
          404 — Page not found
        </p>
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 tracking-tight">
          We couldn't find that page
        </h1>
        <p className="text-gray-500 mb-8 leading-relaxed">
          The link may be broken, or the page may have moved. Head back home or
          jump straight into the tools.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="/"
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg border border-gray-300 bg-white text-gray-800 font-semibold hover:bg-gray-50 transition"
          >
            Back to home
          </a>
          <Link
            to="/tools"
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg text-white font-semibold transition"
            style={{ background: 'linear-gradient(135deg, #4F46E5, #6366F1)' }}
          >
            Open PDF tools
          </Link>
        </div>
      </div>
    </div>
  );
}
